if (checkIfExists('.product-options')) {
  $('.product-options .color').on('click', function(){
    $('.product-options .color').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var price = $(this).data('price');
    $('.last-price').html(price)
    $('.product-options .selected-option').html('('+title+')')
  })

  $('.product-options .option').on('click', function(){
    $('.product-options .option').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var price = $(this).data('price');
    $('.last-price').html(price)
    $('.product-options .selected-option').html('('+title+')')
  })

  $('.product-options .photo').on('click', function(){
    $('.product-options .photo').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var price = $(this).data('price');
    $('.last-price').html(price)
    $('.product-options .selected-option').html('('+title+')')
  })
}


if (checkIfExists('.product-quick-options')) {
  $('.product-quick-options .color').on('click', function(){
    $('.product-quick-options .color').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var price = $(this).data('price');
    $('.quick-order-info .last-price').html(price)
    $('.product-quick-options .selected-option').html('('+title+')')
  })

  $('.product-quick-options .option').on('click', function(){
    $('.product-quick-options .option').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var price = $(this).data('price');
    $('.quick-order-info .last-price').html(price)
    $('.product-quick-options .selected-option').html('('+title+')')
  })

  $('.product-quick-options .photo').on('click', function(){
    $('.product-quick-options .photo').removeClass('active');
    $(this).addClass('active');

    var title = $(this).data('title');
    var price = $(this).data('price');
    $('.quick-order-info .last-price').html(price)
    $('.product-quick-options .selected-option').html('('+title+')')
  })
}

if (checkIfExists('.product-detail')) {
  $('#myTab .nav-item:first .nav-link').addClass('active');
  $('#myTabContent .tab-pane:first').addClass('active show');
  $('#myTabContent table').addClass('table table-striped');
}
